export * from "./Battles.enums";
export * from "./activities.enums";
export * from "./prefferences.enums";
export var ShareImageType;
(function (ShareImageType) {
    ShareImageType[ShareImageType["TWITTER"] = 1] = "TWITTER";
    ShareImageType[ShareImageType["INSTAGRAM_POST"] = 2] = "INSTAGRAM_POST";
    ShareImageType[ShareImageType["INSTAGRAM_STORY"] = 3] = "INSTAGRAM_STORY";
})(ShareImageType || (ShareImageType = {}));
//# sourceMappingURL=index.js.map